import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_continue_promotion_draw_data: { message: "idle" },
};

export const retrieve_continue_promotion_draw_data_Slice = createSlice({
 name: "retrieve_continue_promotion_draw_data",
 initialState,
 reducers: {
  success_retrieve_continue_promotion_draw_data: (state, action) => {
   state.retrieve_continue_promotion_draw_data = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_continue_promotion_draw_data: (state, action) => {
   state.retrieve_continue_promotion_draw_data = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_continue_promotion_draw_data: (state) => {
   state.retrieve_continue_promotion_draw_data = { status: app_consts.IDLE };
  },
  loading_retrieve_continue_promotion_draw_data: (state) => {
   state.retrieve_continue_promotion_draw_data = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_continue_promotion_draw_data, fail_retrieve_continue_promotion_draw_data, reset_retrieve_continue_promotion_draw_data, loading_retrieve_continue_promotion_draw_data } = retrieve_continue_promotion_draw_data_Slice.actions;

export default retrieve_continue_promotion_draw_data_Slice.reducer;